<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 class="h3 mb-0 text-gray-800">Dashboard</h1>
                </div>

                <ng-container *ngIf="loading">
                    <div class="loading text-center">
                        <br />
                        <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                        <br />
                        <p>Loading, please wait...</p>
                    </div>
                </ng-container>

                <ng-container *ngIf="!loading">
                    <div class="noActionButtons" style="margin-top:-62px;">
                        <div class="container-fluid">

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card shadow" style="box-shadow: 0 1rem 1.75rem 0 rgba(58, 59, 69, 0.15) !important;">
                                        <!--today-->
                                        <div class="container-fluid" style="padding: 10px 15px 15px;">
                                            <p><b>Today</b></p>
                                            <div style="overflow:auto;">
                                                <div style="min-width: 625px;">
                                                    <div class="row text-center" style="margin:0px;">
                                                        <div class="col-xs-1 col-sm-1 col-md-1"></div>
                                                        <div class="col-xs-3 col-sm-3 col-md-3"></div>
                                                        <div class="col-xs-2 col-sm-2 col-md-2"><span><b>Purchased</b></span></div>
                                                        <div class="col-xs-2 col-sm-2 col-md-2"><span><b>Assigned</b></span></div>
                                                        <div class="col-xs-2 col-sm-2 col-md-2"><span><b>Completed</b></span></div>
                                                        <div class="col-xs-1 col-sm-1 col-md-1"></div>
                                                    </div>
                                                    <div class="row text-center" style="margin:0px;">
                                                        <div class="col-xs-1 col-sm-1 col-md-1"></div>
                                                        <div class="col-xs-3 col-sm-3 col-md-3"><span><b>Self-Assessments</b></span></div>
                                                        <div class="col-xs-2 col-sm-2 col-md-2"><span>{{selfAssessments.purchased}}</span></div>
                                                        <div class="col-xs-2 col-sm-2 col-md-2"><span>{{selfAssessments.assigned}}</span></div>
                                                        <div class="col-xs-2 col-sm-2 col-md-2"><span>{{selfAssessments.completed}}</span></div>
                                                        <div class="col-xs-1 col-sm-1 col-md-1"></div>
                                                    </div>
                                                    <div class="row text-center" style="margin:0px;">
                                                        <div class="col-xs-1 col-sm-1 col-md-1"></div>
                                                        <div class="col-xs-3 col-sm-3 col-md-3"><span><b>360-Assessments</b></span></div>
                                                        <div class="col-xs-2 col-sm-2 col-md-2"><span>{{assessments360.purchased}}</span></div>
                                                        <div class="col-xs-2 col-sm-2 col-md-2"><span>{{assessments360.assigned}}</span></div>
                                                        <div class="col-xs-2 col-sm-2 col-md-2"><span>{{assessments360.completed}}</span></div>
                                                        <div class="col-xs-1 col-sm-1 col-md-1"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" style="position: relative;top: -17px;">

                                <!--self-->
                                <div class="col-md-6 noPadding" style="padding-right:7.5px !important">
                                    <div class="card shadow container-fluid" style="max-height:550px; min-height:500px;">

                                        <div class="actions selfActions">
                                            <i (click)="setView(1, $event)" class="fas fa-chart-line active"></i>
                                            <i (click)="setView(1, $event)" class="fas fa-table"></i>
                                            <i (click)="exportByAssessmentType(1)" class="fas fa-file-export"></i>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12 text-center">
                                                <p style="margin: 15px 0 0 0;"><b>Self Assessments</b></p>
                                            </div>
                                        </div>

                                        <div>
                                            <!--select-->
                                            <div class="row" style="margin:0px;margin-top:15px;margin-bottom:15px">
                                                <div class="col-xs-offset-2 col-xs-3 col-sm-offset-2 col-sm-2 col-md-offset-2 col-md-2">
                                                    <label style="text-transform: capitalize;">Year: </label>
                                                </div>
                                                <div class="col-xs-5 col-sm-6 col-md-6">
                                                    <select (change)="changeYear(1)" id="selfYear">
                                                        <option *ngFor="let year of years" value="{{year}}" [selected]="year == currentYear">{{year}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="row" style="margin:0px;margin-top:15px;margin-bottom:15px">
                                                <div class="col-xs-offset-2 col-xs-3 col-sm-offset-2 col-sm-2 col-md-offset-2 col-md-2">
                                                    <label style="text-transform: capitalize;">Interval: </label>
                                                </div>
                                                <div class="col-xs-5 col-sm-6 col-md-6">
                                                    <select (change)="changeInterval(1)" id="selfInterval">
                                                        <option *ngFor="let interval of intervals" value="{{interval.value}}" [selected]="interval.value == defaultInterval">{{interval.label}}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <!--content-->
                                            <div class="row">
                                                <div class="col-xs-offset-1 col-xs-10 col-sm-offset-2 col-sm-8 col-md-offset-2 col-md-8 animated fadeIn" id="selfChartWrap">
                                                    <!--chart-->
                                                    <div class="flex" *ngIf="chartReady">
                                                        <div class="flex-item">
                                                            <div style="display: block;">
                                                                <canvas style="max-height:380px;" baseChart width="200" height="200"
                                                                        [datasets]="selfData"
                                                                        [labels]="lineChartLabels"
                                                                        [options]="lineChartOptions"
                                                                        [colors]="lineChartColors"
                                                                        [chartType]="lineChartType"></canvas>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-xs-offset-1 col-xs-10 col-sm-offset-1 col-sm-10 col-md-offset-1 col-md-10 animated fadeIn" id="selfGridWrap" style="display:none;">
                                                    <!--ag grid-->
                                                    <div>
                                                        <div class="table-responsive" style="width: 100%; max-height: 380px; height:380px;">
                                                            <ag-grid-angular #agGrid
                                                                             style="width: 100%; height: 100%;"
                                                                             class="ag-theme-balham"
                                                                             [enableFilter]="true"
                                                                             [gridOptions]="gridOptions"
                                                                             [rowData]="selfGridData"
                                                                             [columnDefs]="gridHeaders"
                                                                             [enableSorting]="true"
                                                                             [enableColResize]="true"
                                                                             (rowClicked)="onRowClicked($event)"
                                                                             (gridReady)="onGridReady(1, $event)"
                                                                             [pagination]="true"
                                                                             [paginationPageSize]="25"
                                                                             [overlayNoRowsTemplate]="overlayNoRowsTemplate">
                                                            </ag-grid-angular>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!--360-->
                                <div class="col-md-6 noPadding" style="padding-left: 7.5px !important;">
                                    <div class="card shadow container-fluid" style="max-height:550px; min-height:500px;">

                                        <div class="actions actions360" style="right: 14px;">
                                            <i (click)="setView(34, $event)" class="fas fa-chart-line active"></i>
                                            <i (click)="setView(34, $event)" class="fas fa-table"></i>
                                            <i (click)="exportByAssessmentType(34)" class="fas fa-file-export"></i>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12 text-center">
                                                <p style="margin: 15px 0 0 0;"><b>360 Assessments</b></p>
                                            </div>
                                        </div>

                                        <div>
                                            <!--select-->
                                            <div class="row" style="margin:0px;margin-top:15px;margin-bottom:15px;">
                                                <div class="col-xs-offset-2 col-xs-3 col-sm-offset-2 col-sm-2 col-md-offset-2 col-md-2">
                                                    <label style="text-transform: capitalize;">Year: </label>
                                                </div>
                                                <div class="col-xs-5 col-sm-6 col-md-6">
                                                    <select (change)="changeYear(34)" id="year360">
                                                        <option *ngFor="let year of years" value="{{year}}" [selected]="year == currentYear">{{year}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="row" style="margin:0px;margin-top:15px;margin-bottom:15px;">
                                                <div class="col-xs-offset-2 col-xs-3 col-sm-offset-2 col-sm-2 col-md-offset-2 col-md-2">
                                                    <label style="text-transform: capitalize;">Interval: </label>
                                                </div>
                                                <div class="col-xs-5 col-sm-6 col-md-6">
                                                    <select (change)="changeInterval(34)" id="interval360">
                                                        <option *ngFor="let interval of intervals" value="{{interval.value}}" [selected]="interval.value == defaultInterval">{{interval.label}}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <!--content-->
                                            <div class="row">
                                                <div class="col-xs-offset-1 col-xs-10 col-sm-offset-2 col-sm-8 col-md-offset-2 col-md-8 animated fadeIn" id="chartWrap360">
                                                    <!--chart-->
                                                    <div class="flex" *ngIf="chartReady">
                                                        <div class="flex-item">
                                                            <div style="display: block;">
                                                                <canvas style="max-height:380px;" baseChart width="200" height="200"
                                                                        [datasets]="assessment360Data"
                                                                        [labels]="lineChartLabels360"
                                                                        [options]="lineChartOptions"
                                                                        [colors]="lineChartColors"
                                                                        [legend]="lineChartLegend"
                                                                        [chartType]="lineChartType"></canvas>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-xs-offset-1 col-xs-10 col-sm-offset-1 col-sm-10 col-md-offset-1 col-md-10 animated fadeIn" id="gridWrap360" style="display:none;">
                                                    <!--ag grid-->
                                                    <div>
                                                        <div class="table-responsive" style="width: 100%; max-height: 380px; height:380px;">
                                                            <ag-grid-angular #agGrid
                                                                             style="width: 100%; height: 100%;"
                                                                             class="ag-theme-balham"
                                                                             [enableFilter]="true"
                                                                             [gridOptions]="gridOptions"
                                                                             [rowData]="GridData360"
                                                                             [columnDefs]="gridHeaders"
                                                                             [enableSorting]="true"
                                                                             [enableColResize]="true"
                                                                             (rowClicked)="onRowClicked($event)"
                                                                             (gridReady)="onGridReady(34, $event)"
                                                                             [pagination]="true"
                                                                             [paginationPageSize]="25"
                                                                             [overlayNoRowsTemplate]="overlayNoRowsTemplate">
                                                            </ag-grid-angular>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </ng-container>
            </div>
        </div>
    </div>
</div>